module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Info-circle-4017f22612b59d1516470120c94b8bb0.svg";